import { render, staticRenderFns } from "./other_setting.vue?vue&type=template&id=57bb558b&"
import script from "./other_setting.vue?vue&type=script&lang=js&"
export * from "./other_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports